module.exports = __webpack_public_path__ + "static/media/galerija_2013 (2).2a607f3a.JPG";